import { useQuery } from 'react-query';
import { listFormulaCards } from 'api/gql-utils/overtime/queries';
import type { OTFormulaCard } from 'api/gql-utils/overtime/types';
import type { OvertimeFormula } from 'components/Settings/AttendanceAndLeavesSettings/types';

export const OVERTIME_FORMULA_CARDS_QUERY_KEY = 'overtime-formula-cards';

const mapApiToFormula = (card: OTFormulaCard): OvertimeFormula => ({
  id: card.id,
  name: card.name,
  rateType: card.rateType,
  multiplier: card.multiplier ?? undefined,
  flatAmount: card.flatRate != null ? card.flatRate : undefined,
  unit: card.rateUnit,
  dailyAllowance: card.dailyAllowance != null ? card.dailyAllowance : undefined,
  isActive: card.status === 'active',
});

export function useOvertimeFormulaCards() {
  return useQuery({
    queryKey: [OVERTIME_FORMULA_CARDS_QUERY_KEY],
    queryFn: () => listFormulaCards(),
    select: (response) => {
      const cards = response.overtimeListFormulaCards.data.otFormulaCards || [];
      return cards.map(mapApiToFormula);
    },
  });
}
